import dayjs from 'dayjs';

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);

export const formatCalendarDate = (date) => {
  const formattedDate = dayjs(date);

  return `${capitalize(formattedDate.format('ddd'))}, ${formattedDate.format('D')} ${capitalize(
    formattedDate.format('MMMM'),
  )}`;
};

export const formatCalendarDateRange = (dates, _isMobile) => {
  if (dates.length <= 1) {
    return formatCalendarDate(dates[0]);
  }

  const start = dayjs(dates[0]);
  const end = dayjs(dates[dates.length - 1]);

  return `${start.format('D')} - ${end.format('D')} ${capitalize(end.format('MMMM'))}`;
};
